module.exports = __webpack_public_path__ + "media/images/athletes/3576-31fde9cf036740d24fdc9c7c9be7df1a.png";